import React, { useState, useCallback, useEffect } from "react";
import { models } from "powerbi-client";
import "powerbi-report-authoring";
import "./PowerBI.css";
import { PowerBIEmbed } from "powerbi-client-react";
import { getPowerBIEmbedToken } from "../../store/services/powerBI.service";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetPowerBiAuthToken } from "../../hooks/useAppToken";
import { Button } from "../CommonUIComponents/Button/Button";
import { ToggleSwitch } from "../CommonUIComponents/ToggleSwitch/ToggleSwitch";
import {
  getPowerBIToggle,
  updatePowerBIToggle,
} from "../../store/services/engagement.service";
import { ApplicationModule } from "../../util/constants";

export function PowerBI() {
  const engagement = useSelector((state) => state.engagement.engagement);
  const { state } = useLocation();
  const user = useSelector((state) => state.user.user);
  const accessToken = useGetPowerBiAuthToken();
  const history = useNavigate();
  const [toggle, setToggle] = useState(true);
  const userConsent = useSelector(
    (state) => state.engagement?.externalUserFlag
  );

  useEffect(() => {
    if(engagement.id){
    setInitialToggle();
    }
  }, [engagement]);

  const setInitialToggle = async () => {
    let request = { engagementId: engagement.id };
    const data = await getPowerBIToggle({ request });
    if (state?.module === ApplicationModule.M1) {
      data.M1_toggle_enable === "Y" ? setToggle(true) : setToggle(false);
    } else if (state?.module === ApplicationModule.M2) {
      data.M2_toggle_enable === "Y" ? setToggle(true) : setToggle(false);
    } else if (state?.module === ApplicationModule.M3) {
      data.M3_toggle_enable === "Y" ? setToggle(true) : setToggle(false);
    } else if (state?.module === ApplicationModule.M4) {
      data.M4_toggle_enable === "Y" ? setToggle(true) : setToggle(false);
    }
  };
  const { module, engagementCode } = state;

  const [reportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,
    permissions: models.Permissions.All,
    viewMode: models.ViewMode.View,
    accessToken: undefined,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
        pageNavigation: {
          visible: false,
        },
      },
    },
  });

  const engagementCodeFilter = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "vw_EngagementMaster",
      column: "EngagementCode",
    },
    operator: "In",
    values: [engagementCode],
    filterType: models.FilterType.BasicFilter,
  };

  const getReport = useCallback(
    async (token) => {
      const response = await getPowerBIEmbedToken({
        request: {
          username: user.username,
          datasetId:
            module === ApplicationModule.M1
              ? process.env.REACT_APP_POWER_BI_DATASET_ID_M1
              : module === ApplicationModule.M2
              ? process.env.REACT_APP_POWER_BI_DATASET_ID_M2
              : module === ApplicationModule.M3
              ? process.env.REACT_APP_POWER_BI_DATASET_ID_M3
              : module === ApplicationModule.M4
              ? process.env.REACT_APP_POWER_BI_DATASET_ID_M4
              : "",
          accessToken: token,
          baseUrl: process.env.REACT_APP_API_URL_REG_US,
          module: module,
        },
      });

      const reportConfig = {
        Id: response.reportId,
        EmbedUrl: response.embedUrl,
        Type: "PowerBIReport",
        EmbedToken: {
          Token: response.embedToken,
          TokenId: response.embedTokenId,
          Expiration: response.expiration,
        },
        MinutesToExpiration: 1,
        AccessToken: response.embedToken,
        DefaultPage: null,
        MobileDefaultPage: null,
        settings: {
          navContentPaneEnabled: false,
          layoutType: models.LayoutType.Custom,
          customLayout: {
              displayOption: models.DisplayOption.FitToWidth
          },
          panes: {
            filters: {
              expanded: false,
              visible: false,
            },
          },
        },
        filters: [engagementCodeFilter],
      };

      setReportConfig({
        ...reportConfig,
        embedUrl: reportConfig.EmbedUrl,
        accessToken: reportConfig.AccessToken,
      });
    },
    [state?.reportId]
  );

  useEffect(() => {
    if (!accessToken) return;

    getReport(accessToken);
  }, [getReport, accessToken]);

  const goBack = () => {
    history(-1);
  };

  const replaceToggle = async (event) => {
    setToggle(!toggle);
    let request = {
      module: state?.module,
      engagementId: engagement.id,
      flagValue: event.target.checked ? "Y" : "N",
    };
    const data = await updatePowerBIToggle({ request });
  };

  return (
    <>
      <PowerBIEmbed
        embedConfig={reportConfig}
        eventHandlers={
          new Map([
            [
              "loaded",
              function () {
                console.log("Report loaded");
              },
            ],
            [
              "rendered",
              function () {
                console.log("Report rendered");
              },
            ],
            [
              "error",
              function (event) {
                console.log(event.detail);
              },
            ],
          ])
        }
        cssClassName={"report-container"}
        getEmbeddedComponent={(embeddedReport) => {
          window.Report = embeddedReport;
        }}
      />
      <div className="powerbi-button">
        <Button
          variant="primary-alt"
          onClick={() => {
            goBack();
          }}
        >
          {"Close"}
        </Button>
        {!userConsent && (
          <div className="toggleButtonPowerBi">
            <span>{"Enable PowerBI for external users"}</span>
            <ToggleSwitch
              offLabel={"No"}
              onLabel={"Yes"}
              id={"powerBi-toggle"}
              onToggle={replaceToggle}
              toggleChecked={toggle}
            ></ToggleSwitch>
          </div>
        )}
      </div>
    </>
  );
}
